module.exports = __webpack_public_path__ + "img/full4-min.85ba228d.png";